import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  useToast,
} from '@ais-ui/ui-core';
import React, { useState } from 'react';
import { useDeleteAton, useDeleteMessageSchedule } from '@ais-ui/api';
import { Schedule } from '@ais-ui/api-spec/config';
import { mutateCallbacks } from '../../utils/mutateCallbacks';
import { useLocalization } from '@ais-ui/locale-management';

interface DeleteMessageScheduleProps {
  messageSchedule: Schedule;
  showDialog: boolean;
  setShowDialog: React.Dispatch<React.SetStateAction<boolean>>;
}

export function DeleteMessageSchedule({
  messageSchedule,
  showDialog,
  setShowDialog,
}: DeleteMessageScheduleProps) {
  const { messages } = useLocalization();
  const { mutate } = useDeleteMessageSchedule();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { toast } = useToast();

  const onDelete = (event: React.FormEvent) => {
    event.preventDefault();

    const scheduleName = messageSchedule.schedMsgName
      ? messageSchedule.schedMsgName
      : 'unknown message schedule';

    setIsSubmitting(true);

    const callBacks = mutateCallbacks(
      toast,
      messages,
      'delete',
      'message schedule',
      setIsSubmitting,
      setShowDialog
    );

    if (!messageSchedule.uid) {
      toast({
        className: 'delete-message-schedule-error-toast',
        title: messages.genericToastTitleError,
        description: messages.messageScheduleDeleteFailed.replace(
          '{label}',
          scheduleName
        ),
        variant: 'destructive',
      });
      setShowDialog(false);
      setIsSubmitting(false);
      return;
    }

    mutate(messageSchedule.uid, callBacks);
  };

  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent id="mutate-aton-dialog">
        <DialogHeader>
          <DialogTitle>{messages.messageScheduleDeleteTitle}</DialogTitle>
          <DialogDescription>
            {messages.messageScheduleDeleteWarning}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onDelete}>
          <div className="grid grid-cols-[auto_minmax(50%,_1fr)] 4 gap-x-2 items-baseline">
            <Label className="font-light">Delete</Label>
            <Label htmlFor="schedule-message-name">
              {messageSchedule.schedMsgName}
            </Label>
          </div>
          <DialogFooter className="p-4">
            <Button
              variant="destructive"
              id="message-schedule-confirm-delete-button"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting
                ? messages.genericSubmitting
                : messages.genericSubmit}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
